import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_armor} from "../_signals/s_char";
import {ICharArmor} from "../_interfaces/ICharArmor";

export const ArmorGet = (cid: string) => {
    fetch(apiAddress + "/char/armor/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
            console.log('BEArmor get reponse', data);

            if (data.hasOwnProperty('result')) {
                    console.log('BEArmor get reponse', data.result);
                    s_char_armor.value = (data.result as ICharArmor[])
                }
            }
        )
        .catch((reason => {
            console.log('BEArmor get catch', reason);
        }))
}

export const ArmorCreate = (armor: ICharArmor) => {
    fetch(apiAddress + "/char/armor/", createOptions('CREATE', armor))
        .then((res) => res.json())
        .then((data) => console.log('BEWArmor create reponse', data))
        .catch((reason => console.log('BEArmor create catch', reason)))
}

export const ArmorUpdate = (armor: ICharArmor) => {
    fetch(apiAddress + "/char/armor/", createOptions('UPDATE', armor))
        .then((res) => res.json())
        .then((data) => console.log('BEArmor update repsonse', data))
        .catch((reason => console.log('BEArmor update catch', reason)))
}

export const ArmorDelete = (armor: ICharArmor) => {
    fetch(apiAddress + "/char/armor/", createOptions('DELETE', armor))
        .then((res) => res.json())
        .then((data) => console.log('BEArmor delete repsonse', data))
        .catch((reason => console.log('BEArmor delete catch', reason)))
}